import { Link } from '../components/Link.tsx';
import { MarketingFooter } from '../components/marketing/MarketingFooter.tsx';
import { DemoPlayer } from '../components/marketing/DemoPlayer.tsx';
import { useDocumentTitle } from '../hooks/useDocumentTitle.ts';
import { useT } from '../i18n.ts';
import '../styles/marketing.css';

// The product demo page (the Evaluate surface — see docs/user-education.md):
// the full chaptered walkthrough video with chapter navigation, for a
// prospect deciding whether Goalpost fits without a sales call.
export function Demo() {
  const t = useT();
  useDocumentTitle(t('demo.document-title'));

  return (
    <div className="mkt-page">
      {/* Compact lead-in rather than the shared centered Hero: the video is
          the page, so the headline shrinks, left-aligns, and shares the
          player's 1080px frame and left edge. */}
      <section className="mkt-hero mkt-hero-lead mkt-hero-compact">
        <div className="mkt-container">
          <span className="mkt-eyebrow">{t('demo.hero.eyebrow')}</span>
          <h1 className="mkt-h1">{t('demo.hero.title')}</h1>
          <p className="mkt-lede">{t('demo.hero.lede')}</p>
          <div className="mkt-cta-row">
            <Link to="/register" className="mkt-btn primary lg">
              {t('demo.hero.cta-try')}
            </Link>
            <Link to="/dashboard" className="mkt-btn ghost lg">
              {t('marketing.cta.login')}
            </Link>
          </div>
        </div>
      </section>

      {/* The demo itself: player plus seek-on-click chapter rail. */}
      <section
        className="mkt-section sunk"
        data-gp-name="demo-player"
        data-gp-observe-impression="true"
      >
        <div className="mkt-container">
          <DemoPlayer
            base="product-demo-software"
            label={t('demo.player.video-label')}
            chaptersLabel={t('demo.player.chapters-heading')}
            introTitle={t('demo.player.chapter-welcome')}
          />
        </div>
      </section>

      {/* CTA */}
      <section className="mkt-cta-strip">
        <div className="mkt-container-narrow">
          <h2 className="mkt-h2">{t('demo.cta.heading')}</h2>
          <p className="mkt-section-lede">{t('demo.cta.lede')}</p>
          <div className="mkt-cta-row">
            <Link to="/register" className="mkt-btn primary lg">
              {t('marketing.cta.signup-free')}
            </Link>
            <Link to="/dashboard" className="mkt-btn ghost lg">
              {t('marketing.cta.login')}
            </Link>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
